import React, { useEffect, useState } from 'react';
import { useConstructorStore } from './store/constructorStore';
import { t } from './i18n';
import { Step1Info } from './constructor/Step1Info';
import { Step2Location } from './constructor/Step2Location';
import { Step3Items } from './constructor/Step3Items';
import { Step4Style } from './constructor/Step4Style';
import { Step5Preview } from './constructor/Step5Preview';
import { MyLandings } from './pages/MyLandings';

type Page = 'constructor' | 'my_landings';

const App: React.FC = () => {
  const [page, setPage] = useState<Page>('constructor');
  const { step, language, totalSteps, prevStep, nextStep } = useConstructorStore();

  // Инициализация Telegram WebApp
  useEffect(() => {
    const tg = (window as any).Telegram?.WebApp;
    if (tg) {
      tg.ready();
      tg.expand();
      // Скрываем стандартную кнопку Telegram, у нас свои
      tg.MainButton.hide(); 
      
      // Определяем язык из Telegram
      const tgLang = tg.initDataUnsafe?.user?.language_code || 'ru';
      useConstructorStore.getState().setField('language', ['ru', 'kk'].includes(tgLang) ? tgLang : 'ru');
    }
  }, []);

  const handleMainButton = () => {
    if (step < totalSteps) {
      nextStep();
    } else {
      // На последнем шаге — оплата
      useConstructorStore.getState().setField('language', language); // no-op, для примера
    }
  };

  return (
    <div className="app">
      {/* Переключатель страниц */}
      <div style={{ display: 'flex', gap: 8, padding: 12, borderBottom: '1px solid #eee' }}>
        <button
          onClick={() => setPage('constructor')}
          style={{
            flex: 1, padding: 8, border: 'none', borderRadius: 8,
            background: page === 'constructor' ? '#1a1a2e' : '#f0f0f0',
            color: page === 'constructor' ? 'white' : '#333',
            fontWeight: 600, fontSize: 14, cursor: 'pointer',
          }}
        >
          🛠️ Конструктор
        </button>
        <button
          onClick={() => setPage('my_landings')}
          style={{
            flex: 1, padding: 8, border: 'none', borderRadius: 8,
            background: page === 'my_landings' ? '#1a1a2e' : '#f0f0f0',
            color: page === 'my_landings' ? 'white' : '#333',
            fontWeight: 600, fontSize: 14, cursor: 'pointer',
          }}
        >
          📋 Мои лендинги
        </button>
      </div>

      {/* Язык переключатель */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '8px 12px' }}>
        <button onClick={() => useConstructorStore.getState().setField('language', 'ru')}
          style={{ padding: '4px 8px', border: language === 'ru' ? '2px solid #1a1a2e' : '1px solid #ddd', borderRadius: 6, background: 'transparent', cursor: 'pointer', fontSize: 12 }}>
          RU
        </button>
        <button onClick={() => useConstructorStore.getState().setField('language', 'kk')}
          style={{ padding: '4px 8px', border: language === 'kk' ? '2px solid #1a1a2e' : '1px solid #ddd', borderRadius: 6, background: 'transparent', cursor: 'pointer', fontSize: 12 }}>
          KK
        </button>
      </div>

      {/* Контент */}
      {page === 'constructor' ? (
        <>
          {/* Индикатор шагов */}
          <div style={{ padding: '8px 12px', background: '#f8f9fa' }}>
            <div style={{ fontSize: 13, color: '#666', marginBottom: 4 }}>
              {t('step', language, { current: String(step), total: String(totalSteps) })}
            </div>
            <div style={{ display: 'flex', gap: 4 }}>
              {Array.from({ length: totalSteps }).map((_, i) => (
                <div key={i} style={{
                  flex: 1, height: 4, borderRadius: 2,
                  background: i < step ? '#1a1a2e' : '#e0e0e0',
                }} />
              ))}
            </div>
          </div>

          {/* Шаги */}
          <div style={{ padding: 16, paddingBottom: 80 }}>
            {step === 1 && <Step1Info />}
            {step === 2 && <Step2Location />}
            {step === 3 && <Step3Items />}
            {step === 4 && <Step4Style />}
            {step === 5 && <Step5Preview />}
          </div>

          {/* Навигация (скрываем на последнем шаге, там своя кнопка оплаты) */}
          {step < totalSteps && (
          <div style={{
            position: 'fixed', bottom: 0, left: 0, right: 0,
            padding: 12, background: 'white', borderTop: '1px solid #eee',
            display: 'flex', gap: 8, zIndex: 1000,
          }}>
            {step > 1 && (
              <button onClick={prevStep} style={{
                padding: '12px 24px', border: '1px solid #ddd', borderRadius: 8,
                background: 'white', fontSize: 16, fontWeight: 600, cursor: 'pointer',
              }}>
                {t('back', language)}
              </button>
            )}
            <button onClick={handleMainButton} style={{
              flex: 1, padding: '12px 24px', border: 'none', borderRadius: 8,
              background: '#1a1a2e', color: 'white', fontSize: 16, fontWeight: 600, cursor: 'pointer',
            }}>
              {t('next', language)}
            </button>
          </div>
          )}
        </>
      ) : (
        <MyLandings />
      )}
    </div>
  );
};

export default App;
